import { render, staticRenderFns } from "./EditActivityNameDialog.vue?vue&type=template&id=5fb2bb6f&scoped=true&"
import script from "./EditActivityNameDialog.vue?vue&type=script&lang=js&"
export * from "./EditActivityNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2bb6f",
  null
  
)

export default component.exports